export const classifications = [
    {classificationName: 'None', classificationId: 31},
    {classificationName: 'Positive w/Amount', classificationId: 1},
    {classificationName: 'Positive no Amount', classificationId: 2},
    {classificationName: 'Negative - DNC-Skill', classificationId: 3},
    {classificationName: 'Negative - DNC-BU', classificationId: 4},
    {classificationName: 'Negative', classificationId: 5},
    {classificationName: 'Other', classificationId: 6},
    {classificationName: 'Retry - Rescheduled Agent Specific', classificationId: 7},
    {classificationName: 'Retry - Rescheduled Specified Date/Time - any agent', classificationId: 8},
    {classificationName: 'Retry - Rescheduled later date/time unspecified', classificationId: 9},
    {classificationName: 'Retry - Not Available', classificationId: 10},
    {classificationName: 'Retry - Answering Machine', classificationId: 11},
    {classificationName: 'Final - Answering Machine', classificationId: 12},
    {classificationName: 'Fax Machine', classificationId: 13}
];

